import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";


@Options({
    template: require("../templates/made-buttons.njk"),
})
export default class MadeButtons extends Marionette.View<Backbone.Model>{

}



// WEBPACK FOOTER //
// ./@modules/button-logic/views/made-buttons.ts